// الحدث يُلتقط في index.html قبل تحميل هذه الحزمة، فنبدأ من القيمة المحفوظة هناك
let installPrompt = (typeof window !== 'undefined' && window.__bhInstall) || null;
const listeners = new Set();

const notify = () => listeners.forEach((listener) => listener(Boolean(installPrompt)));

if (typeof window !== 'undefined') {
  window.addEventListener('bh-install-ready',()=>{installPrompt=window.__bhInstall;notify();});
  window.addEventListener('bh-install-done',()=>{installPrompt=null;notify();});
  window.addEventListener('beforeinstallprompt',(event)=>{event.preventDefault();installPrompt=event;notify();});
  window.addEventListener('appinstalled',()=>{installPrompt=null;notify();});
}

export const subscribeInstall = (listener) => { listeners.add(listener); listener(Boolean(installPrompt)); return () => listeners.delete(listener); };
export const canInstall = () => Boolean(installPrompt);
export async function requestInstall(){if(!installPrompt)return false;await installPrompt.prompt();const choice=await installPrompt.userChoice;installPrompt=null;notify();return choice.outcome==='accepted';}


// ── كشف توفّر نسخة جديدة من التطبيق ──
const updateListeners = new Set();
let waitingWorker = null;
const notifyUpdate = () => updateListeners.forEach((l) => l(Boolean(waitingWorker)));

export const subscribeUpdate = (listener) => {
  updateListeners.add(listener);
  listener(Boolean(waitingWorker));
  return () => updateListeners.delete(listener);
};

export function applyUpdate() {
  if (waitingWorker) waitingWorker.postMessage('SKIP_WAITING');
  setTimeout(() => window.location.reload(), 250);
}

if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then((reg) => {
    if (reg.waiting) { waitingWorker = reg.waiting; notifyUpdate(); }
    reg.addEventListener('updatefound', () => {
      const sw = reg.installing;
      if (!sw) return;
      sw.addEventListener('statechange', () => {
        if (sw.state === 'installed' && navigator.serviceWorker.controller) {
          waitingWorker = sw; notifyUpdate();
        }
      });
    });
    // تحقّق من التحديثات عند فتح التطبيق وكل 5 دقائق
    reg.update().catch(() => {});
    setInterval(() => reg.update().catch(() => {}), 5 * 60_000);
  }).catch(() => {});
  // لا نعيد التحميل تلقائياً عند تغيّر المتحكم — يسبب حلقة إعادة تحميل
  // عند أول تثبيت. إعادة التحميل تتم فقط عند ضغط «تحديث الآن».
}
